
export default {
    name: 'VueHoverMask',
    props: {
        trigger: {
            type: String,
            default: 'hover'
        },
        btns: {
            type: Array,
            default: () => [
                {
                    text: '查看详情',
                    class: 'blue-btn',
                    type: 'viewDetails',
                    method: (val) => {
                        console.log(val, `=========>val`)
                    }
                },
                {
                    text: '继续咨询',
                    class: 'red-jianbian-btn',
                    type: 'consult',
                    method: (val) => {
                        console.log(val, `=========>val`)
                    }
                },
                {
                    text: '立即浏览',
                    class: 'red-jianbian-btn',
                    type: 'nowView',
                    method: (val) => {
                        console.log(val, `=========>val`)
                    }
                }
            ]
        }
    },
    data() {
        return {
            showMask: false
        }
    },
    methods: {
        handleClick() {
            this.$emit('click')
        },
        handleClickShowMask() {
            this.showMask = !this.showMask
            this.$emit('click')
        },
        maskHandler(type) {
            console.log(type, `=========>type`)
        }
    }
}
